<template>
  <div class="confirm" data-modal="confirm">
    <div class="inner">
      <div class="confirm-text">
        <p v-html="text.replace('\n', '<br>')"></p>
      </div>
      <div class="confirm-buttons">
        <button @click.prevent="close" class="confirm-cancel">취소</button>
        <button @click.prevent="confirm" class="confirm-ok">확인</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  disableBodyScrollKeepPosition,
  enableBodyScrollKeepPosition
} from '@/common/util/ui.utils'

export default {
  name: 'ConfirmModal',
  props: ['text', 'resolveFn'],
  methods: {
    confirm () {
      this.resolveFn(true)
      this.$emit('close')
    },
    close () {
      this.resolveFn(false)
      this.$emit('close')
    }
  },
  mounted () {
    disableBodyScrollKeepPosition()
  },
  beforeDestroy () {
    enableBodyScrollKeepPosition()
  },
  watch: {
    $route () {
      const cancelBtn = document.querySelector('.confirm-cancel')
      if (cancelBtn) {
        cancelBtn.click()
      }
    }
  }
}
</script>

<style scoped>
  .confirm {
    padding: 15px 10px 10px 10px;
    height: auto;
    max-width: 300px;
    text-align: center;
    font-family: -apple-system, SF UI Text, Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 14px;
    line-height: 1.4;
    overflow: hidden;
    background-color: #fff;
    margin: auto 0;
  }
  .confirm-buttons {
    float: right;
  }
  .confirm-buttons button {
    color: blue;
    font-size: 14px;
    padding: 0 15px 0 0;
  }
  .confirm-text {
    padding: 10px 0 10px 0;
  }
  .confirm-ok {
    font-weight: 700;
  }
</style>
